<div class="">
  <nav class="navbar navbar-expand-lg navbar-light">
    <form class="col form-inline my-2 my-lg-0">
      <input
        type="text"
        class="form-control"
        pInputText
        size="30"
        placeholder="Search Farmer"
        (input)="usage.filterGlobal($event.target.value, 'contains')"
      />
      <span
        type="submit"
        class="ui-dropdown-filter-icon pi pi-search"
        style="margin-inline-start: -30px"
      ></span>
    </form>
    <button
      class="ui-btn ml-auto"
      (click)="usage.exportCSV({ selectionOnly: true })"
    >
      <i aria-hidden="true" class="fa fa-download"></i>Download ({{
        selectedItems.length
      }})
    </button>
    <p-calendar
      placeholder="Select Date"
      #range_Dates="ngModel"
      id="rangeDates"
      inputId="range_date"
      [(ngModel)]="rangeDates"
      inputId="rangeDates"
      yearRange="2000:2030"
      selectionMode="range"
      [monthNavigator]="true"
      [yearNavigator]="true"
      [readonlyInput]="true"
      [showButtonBar]="true"
      (onClickOutside)="filterByDate($event)"
      (onClose)="filterByDate($event)"
      (onClearClick)="filterByDate($event)"
      #calendar
    >
    </p-calendar>
  </nav>
  <div class="">
    <div class="overlay-container">
      <span>
        <p-table
          #usage
          [columns]="cols"
          [value]="usageList"
          styleClass="table table-primary"
          [paginator]="true"
          [rows]="limit"
          [totalRecords]="usageList.length"
          [(selection)]="selectedItems"
          [globalFilterFields]="['name', 'location', 'phoneNumber']"
          [loading]="isLoading$ | async"
          [exportFilename]="exportName"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th>Farmer</th>
              <th>Customer Type</th>
              <th>Address</th>
              <th>Crop</th>
              <th>Last Action</th>
              <th [pSortableColumn]="'lastSession'">
                Time
                <p-sortIcon [field]="'lastSession'"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-usage>
            <tr>
              <td>
                <p-tableCheckbox [value]="usage"></p-tableCheckbox>
              </td>
              <td>
                <div class="font-weight-bold">{{ usage.name || "NA" }}</div>
                <div>{{ usage.phoneNumber || "NA" }}</div>
              </td>
              <td>
                <div class="font-weight-bold">
                  {{ usage.enterprise | titlecase }}
                </div>
                <div>{{ usage.userId }}</div>
              </td>
              <td>{{ usage.location }}</td>
              <td>{{ usage.crop }}</td>

              <td>
                <div class="font-weight-bold">{{ usage.tag }}</div>
                <div *ngIf="usage.productId as productId">
                  Product ID: {{ productId }}
                </div>
              </td>
              <td>{{ usage.lastSession | dateFormatPipe }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="summary"> </ng-template>
        </p-table>
      </span>
    </div>
    <div class="text-center loader" *ngIf="isLoading$ | async">
      <div class="spinner-busage text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</div>
